import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import { CampaignFormPageMessages } from "@/messages/campaigns/campaign-form-page.messages";

import CitiesTags from "./citiesTags";
import ContactsSegment from "./components/ContactSegment";
import ContactInfo from "./contactInfo";
import ContactTags from "./contactTags";

type Props = {
  messages: CampaignFormPageMessages;
};

function ContactsDataTab({ messages }: Props) {
  return (
    <MDBox mt={4}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: 4 }}>
          <MDBox height="100%">
            <ContactTags messages={messages} />
          </MDBox>
        </Grid>
        <Grid size={{ xs: 12, lg: 8 }}>
          <MDBox height="100%">
            <ContactInfo messages={messages} />
          </MDBox>
        </Grid>
        <Grid size={{ xs: 12, lg: 4 }}>
          <CitiesTags messages={messages} />
        </Grid>
        <Grid size={{ xs: 12, lg: 8 }}>
          <ContactsSegment messages={messages} />
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default ContactsDataTab;
